import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router-dom';
import constants from '../../Constants';
import {switchGenderByName, returnEducation, returnOccupation} from '../../utils/updateDriverInfo';

const PolicyHolder = () => {
    return (
        <span>
            - <i>Policyholder</i>
        </span>
    );
}

/*
const AddButton = (props) => {
    const { sequence, onDriverClick } = props;
    console.log(constants);
    return (
        <button
            onClick={() => onDriverClick(sequence)}
            className="btn btn-primary">
            Add
        </button>
    );
}
*/

const Remove = (props) => {
    console.log(constants);
    //const { sequence, onDriverClick } = props;
    return (
        <button
            //onClick={() => onDriverClick(sequence)}
            className="btn btn-danger app-remove-btn">
            <i className={constants.icons.remove} />
            {` Remove`}
        </button>
    );
}

const DriverItem = (props) => {
    const { dateOfBirth, name, isPolicyHolder, id ,gender} = props;
    const genderUpdated = switchGenderByName(props.givenName, props);
    const education = returnEducation(props.givenName);
    const occupation = returnOccupation(props.givenName);
    const yearsOld = moment(dateOfBirth, "YYYYMMDD").fromNow().replace(/ years ago/g, '');
    console.log(yearsOld);
    return (
        <div className="summary-list-item">
            
            <div className="row">
                <div className="col-md-6 item-data">
                    {name} ({yearsOld}) {isPolicyHolder === true ? <PolicyHolder /> : null}
                    <div>                         
                         <p style={{fontWeight:'normal'}}>Married | {genderUpdated} | {education} | {occupation} | Clean Driving Record</p>
                    </div>
                </div>
                
                <div className="col-md-6">
                    {isPolicyHolder === true ? null : <Remove {...props} />}
                    {` `}
                    <Link
                        to={`driver/${id}`}
                        className="btn btn-secondary">
                        <i className={constants.icons.edit} />
                        {` Edit`}
                    </Link>
                </div>
                
            </div>
        </div>
    )
}

export default DriverItem;

DriverItem.propTypes = {
    name: PropTypes.string.isRequired,
    dateOfBirth: PropTypes.number.isRequired,
    isPolicyHolder: PropTypes.bool.isRequired,
    //onDriverClick: PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/QuoteReview/driver/DriverItem.js